/* eslint-env browser */
import container from 'modules/section-content';
import domify from 'domify';
import page from 'modules/ab-page-js';
import metrics from 'modules/metrics';
import signupForm from 'modules/signupForm';
import abSignupForm from 'modules/signupForm/ab-show-password-policy';
import metadata from './data/metadata.json';
import layout from './views/signup.pug';
import abLayout from './views/ab-show-password-policy-signup.pug';
import { abExperimentData, getWinningVariant, SHOW_SIGN_UP_PASSWORD_POLICY } from './abUtils';

export default function register() {
  page('/signup', render);
}

function gatherQueryParams(query = {}, eventsForRemoving = []) {
  return Object.keys(query).reduce((data, key) => {
    if (eventsForRemoving.includes(key)) return data;
    return {
      ...data,
      [key]: query[key]
    };
  }, {});
}

function reportEventsFromReferrer(query) {
  if (query.signUpData) {
    metrics.lib().track('click:signup', JSON.parse(query.signUpData) || {});
  }
  if (query.event) {
    const eventData = gatherQueryParams(query, ['signUpData', 'event']);
    metrics.lib().track(query.event, eventData);
  }
  if (query.anonId) {
    metrics.lib().track('link:anon_id', { trackData: query.anonId });
  }
}

function render(ctx, next) {
  const { AUTH0_CONNECTION } = window.APP_CONFIG_SIGNUP;
  const query = parseQuery(ctx.querystring);
  reportEventsFromReferrer(query);
  // TODO remove when ab show sign up policy ahead of time is finished
  const signupVariant = getWinningVariant(ctx.winningVariants, SHOW_SIGN_UP_PASSWORD_POLICY);
  ctx.showSignupPasswordPolicy = signupVariant === abExperimentData[SHOW_SIGN_UP_PASSWORD_POLICY];
  const selectedLayout = ctx.showSignupPasswordPolicy === true ? abLayout : layout;
  const selectedSignupForm = ctx.showSignupPasswordPolicy === true ? abSignupForm : signupForm;

  const renderOptions = {
    signupFormApp: selectedSignupForm({
      dbConnectionName: AUTH0_CONNECTION
    }),
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(selectedLayout()) })
  };
  container.render(renderOptions);

  return next();
}

function parseQuery(queryString = '') {
  const query = {};
  const pairs = (queryString.substr(0, 1) === '?' ? queryString.substr(1) : queryString).split('&');

  pairs.forEach(e => {
    query[e.split('=')[0]] = e.split('=')[1];
  });

  return query;
}



// WEBPACK FOOTER //
// ./src/pages/signup/signup.js